module.exports = __webpack_public_path__ + "img/icon-partition.4bbace07.png";